import { formatCurrency } from "i18n/utils";

import { currenciesMap } from "../../../../utils/currencies";
import {
  generateCountryText,
  generatePeriodText,
  ParserType,
  TRANSACTION_AMOUNT_DICTIONARY,
} from "./common";

import type { Currency } from "../../../../models/Currency";
import type { RiskRuleVolumeOfTransactionsAlias } from "../../models/RiskRule";

export const volumeOfTransactionsParser: ParserType<RiskRuleVolumeOfTransactionsAlias> = (
  rule,
  bankName
) => {
  const { payload, filter, operator } = rule;

  const baseTextPart = "The total volume of transactions";
  const countryTextPart = generateCountryText({ filter, bankName });
  const periodTextPart = generatePeriodText({ payload });
  const currency = currenciesMap.get(payload.currency);
  const conditionTextPart = generateConditionText({
    operator,
    payload,
    currency: currency ?? { id: payload.currency, decimal: 2 },
  });

  return [
    baseTextPart,
    countryTextPart,
    periodTextPart,
    conditionTextPart,
  ].join("");
};

const generateConditionText = ({
  operator,
  payload,
  currency,
}: Pick<RiskRuleVolumeOfTransactionsAlias, "operator" | "payload"> & {
  currency: Pick<Currency, "id" | "decimal">;
}) => {
  const operatorTranslated = TRANSACTION_AMOUNT_DICTIONARY[operator];

  const amount = formatCurrency({ amount: payload.value, currency });

  return ` was ${operatorTranslated} ${amount}\xa0${payload.currency}`;
};
